import { Link } from "react-router-dom"
import { useEffect, useState } from "react";
import API_BASE_URL from "../../../constants/api";
import axios from "axios";

interface BlogProps {
   style: boolean;
}

interface BlogSummary {
  id: number;
  title: string;
  thumb: string;
  date: string;
}
const Blog = ({ style }: BlogProps) => {

     const [latestPosts, setLatestPosts] = useState<BlogSummary[]>([]);

  useEffect(() => {
   axios.get(`${API_BASE_URL}latest-blogs`)
      .then((res) => setLatestPosts(res.data))
      .catch((err) => console.error('Failed to fetch latest blogs:', err));
     
  }, []);
   return (
      <section className={`blog__post-area ${style ? "blog__post-area-two" : ""}`}>
         <div className="container">
            <div className="row justify-content-center">
               <div className="col-lg-6">
                  <div className="section__title text-center mb-40" >
                     <span className="sub-title">News & Blogs</span>
                     <h2 className="title">Our Latest News Feed</h2>
                     <p>Sharing Experience, Building Excellence—Learn & Grow with the Community.</p>
                  </div>
               </div>
            </div>

            <div className="row gutter-20 " >
               {latestPosts.map((item) => (
                  <div key={item.id} className="col-xl-3 col-md-6" >
                     <div className="blog__post-item shine__animate-item">
                        <div className="blog__post-thumb">
                           <Link to="/blog-details" className="shine__animate-link"><img src={item.thumb} alt="img" /></Link>
                           {/* <Link to="/blog" className="post-tag">{item.tag}</Link> */}
                        </div>
                        <div className="blog__post-content">
                           <div className="blog__post-meta">
                              <ul className="list-wrap">
                                 <li>
                                 {new Date(item.date).toLocaleDateString('en-US', {
                                                day: '2-digit',
                                                month: 'long',
                                                year: 'numeric'
                                             })}
                                </li>
                                 <li><i className="flaticon-user-1"></i>by <Link to={`/blog-details/${item.id}`}>Admin</Link></li>
                              </ul>
                           </div>
                           <h4 className="title"><Link to={`/blog-details/${item.id}`}>{item.title}</Link></h4>
                        </div>
                     </div>
                  </div>
               ))}
            </div>
         </div>
      </section>
   )
}

export default Blog
